import React from 'react'
import * as Displays from '@morningtrain/react-displays'
import * as UI from 'ui'
import { useValue } from '@morningtrain/react-resources'

export default function OrderStatusText () {
  const status = useValue('status')

  let color = null

  switch (status) {
    case 'draft':
      color = 'gray'
      break
    case 'pending':
      color = 'red'
      break
    case 'completed':
      color = 'yellow'
      break
    case 'received':
      color = 'green'
      break
  }

  return (
    <UI.StatusText
      color={color}
      bigText
      subtitle={(
        <>
          <Displays.Text name='supplier.name' />
          <br />
          <Displays.Text name='department.name' />
        </>
      )}
    >
      <Displays.Date name='updated_at' />
    </UI.StatusText>
  )
}
